import React, { useMemo } from "react";
import { Box } from "@material-ui/core";
import { useLocation } from "react-router-dom";

import { Transaction, BillTransaction, BillType } from "../../../api/services";
import { CustomLink } from "../../../components/CustomLink";

export const TransactionDetailsLink: React.FC<{
  transaction: Transaction;
}> = ({ transaction }) => {
  const { type, isCancellation } = transaction;
  const { pathname } = useLocation();
  const link = useMemo(() => {
    if (isCancellation) {
      return null;
    }
    if (type !== "Bill" && type !== "CreditNote") {
      return null;
    }
    const { number } = transaction as BillTransaction;
    if (number == null) {
      return null;
    }
    const subPath = type !== "CreditNote" ? "bills" : "credits";
    return `${pathname}/${subPath}/${encodeURIComponent(number)}`;
  }, [isCancellation, pathname, transaction, type]);

  return link != null ? <CustomLink to={link}>Details</CustomLink> : null;
};

export const BillDetailsLink: React.FC<{
  billType: BillType;
  number: string;
}> = ({ billType, number }) => {
  const { pathname } = useLocation();

  const link = useMemo(() => {
    if (number == null) {
      return null;
    }
    if (billType === "CreditNote") {
      return `${pathname}/credits/${encodeURIComponent(number)}`;
    } else {
      if (pathname.endsWith("/bills")) {
        return `${pathname}/${encodeURIComponent(number)}`;
      } else {
        return `${pathname}/bills/${encodeURIComponent(number)}`;
      }
    }
  }, [number, pathname, billType]);

  return link != null ? (
    <Box>
      <CustomLink to={link}>Details</CustomLink>
    </Box>
  ) : null;
};
